/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiDefPricingInfo } from '../../models/api-def-pricing-info';

export interface PricingGetPricingPlans$Params {
}

export function pricingGetPricingPlans(http: HttpClient, rootUrl: string, params?: PricingGetPricingPlans$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'pricingInfo'?: ApiDefPricingInfo;
}>> {
  const rb = new RequestBuilder(rootUrl, pricingGetPricingPlans.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'pricingInfo'?: ApiDefPricingInfo;
      }>;
    })
  );
}

pricingGetPricingPlans.PATH = '/pricingPlans';
